export default {
  ACCOUNT: "fas fa-user-circle",
  BULLHORN_ICON: "fas fa-bullhorn",
  ID_ICON: "fas fa-id-card",
  HELP_ICON: "fas fa-question-circle",
  SETTINGS_ICON: "fas fa-cog",
  // TROPHY_ICON: "fas fa-trophy", // no longer used as we are using the WBC trophy icon svg
  USERS_ICON: "fas fa-users",
  EMAIL_NOTIFICATIONS_ICON: "fas fa-paper-plane",
  ROSTER_SUBMISSIONS_ICON: "fas fa-clipboard-list"
};
